import {clientsClaim as workbox_core_clientsClaim} from 'C:/CODIGOFUENTES/LD_LOGIN/FUENTES/LD_LOGIN/LD_LOGIN/ClientApp/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'C:/CODIGOFUENTES/LD_LOGIN/FUENTES/LD_LOGIN/LD_LOGIN/ClientApp/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "./ClientApp/public/dist/191.1e0287eb6a3c2b924ff5.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/191.1e0287eb6a3c2b924ff5.js.map",
    "revision": "9ecd8999ab0f9d0c0fc3dc12c2ebb57e"
  },
  {
    "url": "./ClientApp/public/dist/191.css",
    "revision": "3fa64383eea645aea9229c8276371029"
  },
  {
    "url": "./ClientApp/public/dist/191.css.map",
    "revision": "ce2d5a72926638529dcd00f9275e4daf"
  },
  {
    "url": "./ClientApp/public/dist/297.60926d52d4b52206e850.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/297.60926d52d4b52206e850.js.map",
    "revision": "40e1fa7ab21921675cc090db7636ce88"
  },
  {
    "url": "./ClientApp/public/dist/398.ae82c13e26e1c42af27e.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/398.ae82c13e26e1c42af27e.js.map",
    "revision": "664515814c9166b8bf765e41207c84f9"
  },
  {
    "url": "./ClientApp/public/dist/398.css",
    "revision": "3fa64383eea645aea9229c8276371029"
  },
  {
    "url": "./ClientApp/public/dist/398.css.map",
    "revision": "6bad4b3e4f318dc4b9190197cfedf389"
  },
  {
    "url": "./ClientApp/public/dist/429.7fe14d9dd4881ec9b1a7.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/429.7fe14d9dd4881ec9b1a7.js.LICENSE.txt",
    "revision": "29c0dc5695466ff613ba65f5bf835499"
  },
  {
    "url": "./ClientApp/public/dist/429.7fe14d9dd4881ec9b1a7.js.map",
    "revision": "0b5ae4cf9f22dc21b9ea0c00d7551b9a"
  },
  {
    "url": "./ClientApp/public/dist/526.93d64c6889609951ffc6.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/526.93d64c6889609951ffc6.js.LICENSE.txt",
    "revision": "4df1586786f28a6e5369394f8233e2fe"
  },
  {
    "url": "./ClientApp/public/dist/526.93d64c6889609951ffc6.js.map",
    "revision": "1dfff9488637c2a31e79d3f241b16537"
  },
  {
    "url": "./ClientApp/public/dist/612.5b0a1c4e26db61936f8c.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/612.5b0a1c4e26db61936f8c.js.map",
    "revision": "845944b01ff68ef46ffae1e403b1bcf9"
  },
  {
    "url": "./ClientApp/public/dist/630.44a3085436e30da3b8e1.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/630.44a3085436e30da3b8e1.js.LICENSE.txt",
    "revision": "29c0dc5695466ff613ba65f5bf835499"
  },
  {
    "url": "./ClientApp/public/dist/630.44a3085436e30da3b8e1.js.map",
    "revision": "bb1dc3acc9b85d6a6adc2e31c5c9dd0f"
  },
  {
    "url": "./ClientApp/public/dist/692.b823f022e9b45b8aff31.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/692.b823f022e9b45b8aff31.js.LICENSE.txt",
    "revision": "dbeaecba8741c0ff61f04d985df6dbce"
  },
  {
    "url": "./ClientApp/public/dist/692.b823f022e9b45b8aff31.js.map",
    "revision": "7c6709f58fd2a120c3e4a4f0f2ffc61e"
  },
  {
    "url": "./ClientApp/public/dist/706.css",
    "revision": "3fa64383eea645aea9229c8276371029"
  },
  {
    "url": "./ClientApp/public/dist/706.css.map",
    "revision": "dc083df71d24040127b7176dc2e52a06"
  },
  {
    "url": "./ClientApp/public/dist/706.ee7b2a0f98817a88ea6c.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/706.ee7b2a0f98817a88ea6c.js.map",
    "revision": "57fbd6aaca93860ad2d90942f1ab8b5b"
  },
  {
    "url": "./ClientApp/public/dist/732.e74b0e25ffa35c3c3794.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/732.e74b0e25ffa35c3c3794.js.LICENSE.txt",
    "revision": "a138a1e6d09cb8e589345030509c9855"
  },
  {
    "url": "./ClientApp/public/dist/732.e74b0e25ffa35c3c3794.js.map",
    "revision": "18ac3702cb60151481ddc9d8cf54b397"
  },
  {
    "url": "./ClientApp/public/dist/78.a42707e9d0385f0fc034.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/78.a42707e9d0385f0fc034.js.LICENSE.txt",
    "revision": "97636669c8193ace9a3b4f1548fc4d0b"
  },
  {
    "url": "./ClientApp/public/dist/78.a42707e9d0385f0fc034.js.map",
    "revision": "7c8dd9d2e05ff55b299ef8f8170788d6"
  },
  {
    "url": "./ClientApp/public/dist/784.6c58cbe4238c14db06f7.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/784.6c58cbe4238c14db06f7.js.map",
    "revision": "04aeb6356c9d89b66952abee87c6919a"
  },
  {
    "url": "./ClientApp/public/dist/826.d58360cd193e4b4685d3.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/826.d58360cd193e4b4685d3.js.map",
    "revision": "791ab377d8917239e94bb104145460c9"
  },
  {
    "url": "./ClientApp/public/dist/84.7427241ecdec50323e98.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/84.7427241ecdec50323e98.js.map",
    "revision": "42e02eb5111d78157046686e6464971c"
  },
  {
    "url": "./ClientApp/public/dist/8c804432e8c67741aac0392c54fc1961.woff",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/950.css",
    "revision": "3fa64383eea645aea9229c8276371029"
  },
  {
    "url": "./ClientApp/public/dist/950.css.map",
    "revision": "623eb40d041f359824199e030adc38dc"
  },
  {
    "url": "./ClientApp/public/dist/959.cb1e1509806e29609148.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/959.cb1e1509806e29609148.js.map",
    "revision": "709e29b5896046c7ed4453298d0eb6fb"
  },
  {
    "url": "./ClientApp/public/dist/app.bc51b8c3d60f9d7fd89a.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/app.bc51b8c3d60f9d7fd89a.js.LICENSE.txt",
    "revision": "a72a948c6e942aef440e7cc7e605eb93"
  },
  {
    "url": "./ClientApp/public/dist/app.bc51b8c3d60f9d7fd89a.js.map",
    "revision": "a124a2bd031932eed83393527e27dfe9"
  },
  {
    "url": "./ClientApp/public/dist/ec3562bf6d6e6d95d60273d5cb18cb14.woff",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/runtimechunk~app.38a5457173a8a12fea8b.js",
    "revision": null
  },
  {
    "url": "./ClientApp/public/dist/runtimechunk~app.38a5457173a8a12fea8b.js.map",
    "revision": "4b8098fe0a0dacf4d6de283ee0176a13"
  },
  {
    "url": "./ClientApp/public/dist/style.css",
    "revision": "fbe7b0283325144a19f816df7eda360a"
  },
  {
    "url": "./ClientApp/public/dist/style.css.map",
    "revision": "8a4cd74bac185c63bf7ddc462a6b5ff2"
  }
], {});








